export default {
  title: 'Histórico de Atividades',

  'menu.import': 'Importar',
  'menu.importHistory': 'Histórico de importação',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Histórico de exportação',
  'menu.unproductives': 'Motivos de Improdutiva',
  'menu.disapproves': 'Motivos de reprovação',
  'menu.canceled': 'Motivos de cancelamento',
  'menu.pendencies': 'Motivos de Pendência',
  'menu.newTrigger': 'Criar automação',
  'menu.triggers': 'Automações',
  'menu.integrations': 'Integrações',
  'menu.fields': 'Customizar campos adicionais',
  'menu.templates': 'Templates de PDF',
  'menu.templateHistory': 'Histórico de Documento',
  'counter.text': 'Registros encontrados',
  'menu.publicToken': 'Tokens públicos',
  'menu.semaphore': 'Configuração de farol',
  'menu.routines': 'Rotinas',
  'actions.viewPdf': 'Ver relatório em PDF',
  'actions.copyLink': 'Copiar link público',
  'actions.linkCopied': 'Link copiado!',
  'actions.linkCopyError': 'Falha ao copiar o link'
}
